module.exports = __webpack_public_path__ + "static/media/location.3fddb28f.png";